export default "__VITE_ASSET__8gX4AslK__"